export enum Direction {
	vertical = "vertical",
	horizontal = "horizontal"
}

export interface ISlider {
	config: ISliderConfig;
	getValue(): number[];
	setValue(value: string | number | number[]): void;
}

export enum SliderEvents {
	change = "change",
	mousedown = "mousedown",
	mouseup = "mouseup"
}


export interface ISliderConfig {
	min: number;
	max: number;
	step: number;
	mode?: Direction;
	range?: boolean;
	value?: number[] | number | string;
	inverse?: boolean;
	thumbLabel?: boolean;
	css?: string;
	tick?: number;
	tickTemplate?: (position: number) => string;
	majorTick?: number;
	label?: string;
	required?: boolean;
	help?: string;
	labelInline?: boolean;
	labelWidth?: string;
	hiddenLabel?: boolean;
}